export default "__VITE_ASSET__S6_kR$ky__"